import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DarkThemePickerService {

  constructor() {
  }

  setTheme() {
    setTimeout(() => {
      this.selectTheme(localStorage.getItem('theme') == 'dark');
    }, 100);
  }

  selectTheme(theme: boolean) {
    const sectionContainer = document.getElementsByClassName("section-container")[0];
    const footerContainer = document.getElementsByClassName("footer-container")[0];

    if (sectionContainer) {
      sectionContainer.classList.toggle("dark-theme", theme);
    }
    if (footerContainer) {
      footerContainer.classList.toggle("dark-theme", theme);
    }
    document.body.classList.toggle("dark-theme-body", theme);
    try {
      localStorage.setItem('theme', theme ? 'dark' : 'light');
    } catch (e) {
      console.error('Cannot save theme to localStorage:', e);
    }
  }

}
